<div class="filters">
  <mat-form-field subscriptSizing="dynamic">
    <mat-select [(value)]="selectedColumn">
      <mat-option value="">Search...</mat-option>
      @for (column of columns; track column.key) {
        @if (column.filterable) {
          <mat-option [value]="column.key">
            {{ column.label }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <span matIconSuffix class="search-icons">
      @if (searchControl.value) {
        <mat-icon (click)="clearSearch()" style="cursor: pointer">close</mat-icon>
      }
      <mat-icon (click)="search()" style="cursor: pointer">search</mat-icon>
    </span>
    <input matInput [placeholder]="searchPlaceholder" [formControl]="searchControl" (keydown.enter)="search()" />
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <mat-select [formControl]="contactTypeControl">
      <mat-option [value]="defaultContactType">All types</mat-option>
      <mat-option [value]="'Person'">Person</mat-option>
      <mat-option [value]="'Department'">Department</mat-option>
    </mat-select>
  </mat-form-field>
</div>
